import { createContext, useContext } from 'react';
import type { Country } from './country';

const CountryContext = createContext<Country | null>(null);

export const CountryProvider = CountryContext.Provider;

export function useCountry(): Country {
  const country = useContext(CountryContext);

  if (!country) {
    throw new Error('Country is not provided');
  }

  return country;
}
